import React from 'react'
import FontAwesome from 'react-fontawesome'
import { addTodoModalOpen } from '../../../redux/actions/todos'
import { Button } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import AddTodoModal from './AddTodoModal'

export default ({ children, kategoria, linkAddress, linkTitle, variant, size, newTaskButtonLabel }) => {
    const dispatch = useDispatch()
    const buttonClick = () => {
        dispatch(addTodoModalOpen({ kategoria, linkAddress, linkTitle }))
    }
    return <>
        <Button variant={variant || "light"} size={size || ''} onClick={buttonClick}>
            <FontAwesome className="text-primary"
                style={{ cursor: "pointer" }}
                title={newTaskButtonLabel}
                name="plus-circle" />
            {children || " " + newTaskButtonLabel}
        </Button>
        <AddTodoModal />
    </>
}